module.exports = __webpack_public_path__ + "media/video104.45ee5171.mp4";